import React from "react";
import AlertSmall from "../vendor/AlertSmall/AlertSmall.js";

export type FormErrorProps = {
  children?: React.ReactNode | undefined;
  className?: string | undefined;
  id?: string | undefined;
  type?: "error" | "warn";
};

export const FormError = ({
  type = "error",
  children,
  ...otherProps
}: FormErrorProps) => {
  return (
    <AlertSmall
      {...otherProps}
      error={type === "error" ? children : undefined}
      warning={type === "warn" ? children : undefined}
      variant="form-field"
    />
  );
};
